define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");

    /**
     * Utility methods for DOM manipulation
     */
    var DomUtils = (function () {
        var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        var cssTransitions = supportsTransitions();

        function supportsTransitions() {
            var body = document.body || document.documentElement,
                style = body.style,
                transition = 'transition';

            if (typeof style[transition] === 'string') { return true; }

            // Tests for vendor specific prop
            var vendor = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
            transition = transition.charAt(0).toUpperCase() + transition.substr(1);

            for (var i=0; i<vendor.length; i++) {
                if (typeof style[vendor[i] + transition] === 'string') { return true; }
            }

            return false;
        }

        return {
            /**
             * Recursively iterate nodes and wrap text that match the input regex with a node of type nodeName and class
             * className.
             *
             * Based on http://bartaz.github.io/sandbox.js/jquery.highlight.html
             *
             * @param node
             * @param re
             * @param nodeName
             * @param className
             * @private
             */
            highlight: function (node, re, nodeName, className) {
                if (node.nodeType === 3) {
                    var match = node.data.match(re);
                    if (match) {
                        var highlight = document.createElement(nodeName || 'span');
                        highlight.className = className || 'highlight';
                        var wordNode = node.splitText(match.index);
                        wordNode.splitText(match[0].length);
                        var wordClone = wordNode.cloneNode(true);
                        highlight.appendChild(wordClone);
                        wordNode.parentNode.replaceChild(highlight, wordNode);
                        return 1; //skip added node in parent
                    }
                } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
                    !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
                    !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
                    for (var i = 0; i < node.childNodes.length; i++) {
                        i += DomUtils.highlight(node.childNodes[i], re, nodeName, className);
                    }
                }
                return 0;
            },

            selectItemText: function (jqueryElement) {
                var element;
                var range;
                var selection;

                if (!isSafari) {
                    jqueryElement.attr("tabindex", "1");
                    jqueryElement.focus();
                    jqueryElement.removeAttr("tabindex", "1");
                }
                if (jqueryElement.length > 0) {
                    element = jqueryElement[0];

                    if (document.body.createTextRange) {

                        range = document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    }
                    else if (window.getSelection) {

                        selection = window.getSelection();
                        range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                }
            },

            // TODO(oded): never appended used for google addwords in registration
            // document.createElement("img").src = src;
            // TODO(oded): yair@security would like to run this through serverside
            injectImgToBody: function (id, src) {
                var body = document.getElementsByTagName('body')[0];
                if (body) {
                    var img = document.createElement("img");
                    img.id = id;      //height="1" width="1" style="border-style:none;"
                    img.height = "1";
                    img.alt = "";
                    img.width = "1";
                    img.style.borderStyle= "none";
                    img.src = src;
                }
            },

            injectIframeToBody: function (id, src) {
                var body = $("body").get(0);
                if (body) {
                    var iframe = document.createElement("iframe");
                    iframe.id = id;
                    iframe.height = "0";
                    iframe.frameborder = "0";
                    iframe.width = "0";
                    //iframe.scrolling = "no";
                    iframe.style = "visibility:hidden;display:none";
                    iframe.src = src;
                    body.appendChild(iframe);
                }
            },

            /**
             * dynamically adds a script tag to the html
             * @param url (mandatory) the url of the script tag
             * @param callback (optional)
             * @param context (optional) the context object for the callback
             * @param tagId (optional) the id of the script tag
             */
            addScriptTag: function (url, callback, context, tagId) {

                if (!url) {
                    throw new Error("DomUtils.addScriptTag - must pass a url for the script to load");
                }

                tagId = tagId || _.uniqueId("stag");

                setTimeout(function () {

                    var s = document.createElement("script");
                    s.setAttribute("type", "text/javascript");
                    s.setAttribute("id", tagId);
                    s.async = true;

                    $(s).load(function () {
                        if (callback) {
                            callback.call(context);
                        }
                    });

                    s.setAttribute("src", url);
                    document.getElementsByTagName("head").item(0).appendChild(s);
                }, 0);
            },

            getPixelCount: function (value) {
                return _.parseInt(value.replace("px", ""));
            },

            /**
             * Finds a parent by recursively traversing up the DOM and matching each level to the passed selector.
             * If no selector was passed, returns the immediate parent.
             * @param el The element to begin the search from.
             * @param selector (Optional) A selector to restrict the search. Will cause the function to stop searching
             * after hitting an element that matches the selector.
             * @returns {*} The first matching parent element according to the selector. If no selector was passed, the
             * immediate parent is returned. If the traverse was over (top of the DOM was reached) without a match,
             * <code>false</code> is returned.
             */
            findParent: function (el, selector) {
                if (_.isUndefined(el)) {
                    throw "el must be defined to find its parent";
                }
                var parent = $(el).parent();
                if (parent.is("html")) {
                    // didn't find a match - prevent max call stack exceeded by returning false
                    return false;
                }
                if (!_.isString(selector)) {
                    // no selector - return immediate parent
                    return parent;
                }
                if (parent.is(selector)) {
                    // found a match - return it
                    return parent;
                }
                // keep looking by traversing up the DOM
                return this.findParent(parent, selector);
            },

            isTransitionSupported: function () {
                return cssTransitions;
            }

        };
    })();

    return DomUtils;
});
